/**
 * These are the values we use at site table's parking_type column
 */

export const COMBO = 'combo';
export const SELF_PARK = 'self-park';
export const VALET = 'valet';

export type ParkingType = typeof SELF_PARK | typeof VALET | typeof COMBO;
